import { memo, useEffect, useState } from "react";
import { BzModal, BzModalBody, BzModalHeader } from '../../components';
import { Row, Col, Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { handleModal } from "../../redux/actions/modals";


const TermsConditionModal = ({ termsAndCondition }) => {
    
    /*Mahesh S  : 15-11-2023 : BT-101819 - Breeze - text changes - Start*/
    const dispatch = useDispatch();
    const modals = useSelector(state => state.modals.modals);
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);

    const handleClose = () => {
        dispatch(handleModal([{ "TERMS_CONDITION_MODAL": false }], true));
    };

    const [isLoggedIn, setIsLoggedIn] = useState(true);
    
    useEffect(() => {
        if (Object?.keys(objLoginSession)?.length > 0) {
            setIsLoggedIn(false);
        } else {
            setIsLoggedIn(true);
        }
    }, [objLoginSession]);
    /*Mahesh S  : 15-11-2023 : BT-101819 - Breeze - text changes - End*/

    return (
        <>

            <BzModal size='lg' show={modals['TERMS_CONDITION_MODAL']} onHide={handleClose} centered className='modal-breeze-lg'>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-self-center'>
                                <div data-testid='terms_conditions_modal_header' className='font-medium font-size4 color-text'>{isLoggedIn ? 'Terms & Conditions' : 'Terms of use'}</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-self-center'>
                                <div data-testid="modal-close" onClick={handleClose} className='icon-16 icon-close icon-dark'></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col>
                                <div className='infodata' dangerouslySetInnerHTML={{ __html: termsAndCondition }}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>
            </BzModal>


        </>
    );
};

export default memo(TermsConditionModal);